module.exports = __webpack_public_path__ + "static/img/01.6dadcd68.webp";